import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import Carousel from "../../components/Carousel/Carousel";
import Promocao from "../../components/ProdutoEmPromoção/index";
import Recentes from "../../components/ProdutoRecente/index";
import Vendidos from "../../components/ProdutoMaisVendido/index";
import styles from "./Home.module.css";
import SubHeader from "../../components/SubHeader/SubHeader";
import CategoryCarousel from '../../components/CategoryCarousel/CategoryCarousel';
import { categories } from '../../utils/category';
import { brands } from '../../utils/brand';
import { Solucoes } from '../../utils/solucoes';
import { useWindowSize } from "../../hooks/useWindowSize";
import { useTranslation } from "react-i18next";

function Home() {
  const { t } = useTranslation(undefined, { keyPrefix: 'home' });
  const { isSmallScreen } = useWindowSize();

  return (
    <div>
      <Header boxShadow isSmallScreen={isSmallScreen} />
      <SubHeader isSmallScreen={isSmallScreen} />
      <Carousel />

      <div className={styles.promocao}>
        <p className={styles.promocaoTitulo}>{t("categories")}</p>
      </div>
      <CategoryCarousel categories={categories} type="categories" />

      <div className={styles.promocao}>
        <p className={styles.promocaoTitulo}>{t('promotions')}</p>
        <a href="/search/1?filter=promocoes" className={styles.mais}>{t('seeMore')}</a>
      </div>
      <Promocao />

      <div className={styles.promocao}>
        <p className={styles.promocaoTitulo}>{t('brands')}</p>
      </div>
      <CategoryCarousel categories={brands} type="brands" />

      <div className={styles.promocao}>
        <p className={styles.promocaoTitulo}>{t('bestSellers')}</p>
        <a href="/search/1?filter=maisVendidos" className={styles.mais}>{t('seeMore')}</a>
      </div>
      <Vendidos />

      <div className={styles.promocao}>
        <p className={styles.promocaoTitulo}>{t('solutions')}</p>
      </div>
      <CategoryCarousel categories={Solucoes} type="problems" />

      <div className={styles.promocao}>
        <p className={styles.promocaoTitulo}>{t('recent')}</p>
        <a href="/search/1?filter=recentes" className={styles.mais}>{t('seeMore')}</a>
      </div>
      <Recentes />

      {!isSmallScreen && <Footer />}
    </div>
  );
}

export default Home;